import styled from '@emotion/styled';
import { blue, primary } from '@styles/Colors';
import FaqContentItem from '.';
import Typography from '@components/_atoms/Typography';
import { TypoVariant } from '@constants/atoms';
import LinkText from '@components/_atoms/Link/LinkText';
import Divider from '@components/_atoms/Divider';
import { FaqContentInfo } from '@pages/customer/faq';
import { CHANNEL_TALK } from '@constants/routes/routes';

const FaqContentItemListContainer = styled.div`
  width: 100%;
  max-width: 1080px;
  display: flex;
  flex-direction: column;
  gap: 60px;
  margin: 0 auto;
`;

const FaqContentItemListWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 40px;
  flex-wrap: wrap;
`;
const InquiryTextWrapper = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  align-self: stretch;

  border-radius: 8px;
  background: ${blue.blue1};
`;

const FaqContentItemWrapper = styled.div`
  width: 100%;
  width: 520px;
  min-width: 520px;
  max-width: 1080px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

const FaqContentItemQuestionAnswerListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;

const FaqContentQuestionAnswerWrapper = styled.div`
  width: 100%;
`;

type Props = {
  faqContentList: FaqContentInfo[];
};

export default function FaqContentItemList({ faqContentList }: Props) {
  return (
    <>
      <FaqContentItemListContainer>
        <FaqContentItemListWrapper>
          {faqContentList.map(
            (item, index) =>
              !!item?.faqContentItemInfoList.length && (
                <FaqContentItemWrapper key={index} style={faqContentList.length === 1 ? { width: '1080px' } : {}}>
                  <Typography variant={TypoVariant.SH2} color={primary.gray}>
                    {item.title}
                  </Typography>
                  <Divider />
                  <FaqContentItemQuestionAnswerListWrapper>
                    {item.faqContentItemInfoList.map((item, index) => (
                      <FaqContentQuestionAnswerWrapper key={index}>
                        <FaqContentItem item={item} />
                      </FaqContentQuestionAnswerWrapper>
                    ))}
                  </FaqContentItemQuestionAnswerListWrapper>
                </FaqContentItemWrapper>
              ),
          )}
        </FaqContentItemListWrapper>
        <InquiryTextWrapper>
          <Typography variant={TypoVariant.B4}>다른 도움이 필요하시다면&nbsp;</Typography>
          <LinkText href={CHANNEL_TALK}>1:1 문의하기</LinkText>
          <Typography variant={TypoVariant.B4}>를 눌러주세요!</Typography>
        </InquiryTextWrapper>
      </FaqContentItemListContainer>
    </>
  );
}
